module.exports = __webpack_public_path__ + "img/asx_out.c015465d.jpg";